/* eslint-disable react/jsx-wrap-multilines */
import React, { Component } from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { ClickableBox } from '../../Components';
import { OrderConfirmationPDF } from '../OrderConfirmationPDF';
import { buildOrderPDF } from '../OrderConfirmationPDF/utils/buildOrderPDF';
import { getOrderForId } from '../../selectors';

export class OrderPDFButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: this.props.id,
      status: this.props.status,
      orderData: null,
    };
  }

  onClick = () => {
    const { context } = this.props;
    let order = getOrderForId(context)(this.state.id);
    if (order !== undefined) {
      order = order.doc;
    }

    const orderData = order ? buildOrderPDF(context, order) : null;
    this.setState({ orderData });
  };

  render() {
    // if (this.state.status !== 'done') {
    //   return <div />;
    // }

    if (this.state.orderData !== null) {
      const fn = (this.status === 'done') ? 'bestellbestatigung.pdf' : 'bestellvorschlag.pdf';
      return (
        <PDFDownloadLink
          document={<OrderConfirmationPDF order={this.state.orderData} />}
          fileName={fn}>
          {({ loading }) => {
            if (loading) {
              return <div>Loading</div>;
            }
            return <div>Download PDF</div>;
          }}
        </PDFDownloadLink>
      );
    }

    return <ClickableBox onClick={this.onClick}>Prepare PDF</ClickableBox>;
  }
}
